import React from 'react';
import { motion, useMotionValue, useTransform, animate } from 'framer-motion';
import { useEffect } from 'react';

// Pomocná komponenta pro animované číslo
const Counter = ({ from, to }) => {
  const count = useMotionValue(from);
  const rounded = useTransform(count, (latest) => Math.round(latest));
  
  useEffect(() => {
    // Animace se spustí, jakmile se komponenta objeví
    const controls = animate(count, to, { duration: 4, ease: "easeOut" });
    return controls.stop;
  }, [count, to]);

  return <motion.span>{rounded}</motion.span>;
};

const About = () => {
  return (
    <section id="about" style={{ backgroundColor: '#FEF0D7', padding: '100px 20px', color: '#2b1f18', overflow: 'hidden' }}>
      <motion.div 
        style={{ maxWidth: '1200px', margin: 'auto', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '40px' }}
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
      >
        {/* TEXTOVÁ ČÁST */}
        <div style={{ flex: '1', minWidth: '300px' }}>
          <motion.p 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            style={{ fontStyle: 'italic', fontSize: '1.3rem' }}
          >
            Řemeslo skrz věky
          </motion.p>
          
          <h2 style={{ fontSize: '2.5rem', fontWeight: '700', margin: '20px 0' }}>Od dávných kořenů k mistrovství</h2>
          <p>Od návrhu až po dokončení spolupracujeme na tvorbě jedinečných řešení.</p>
          
          {/* STATISTIKY S ANIMOVANÝM ČÍSLEM */}
          <div style={{ display: 'flex', gap: '40px', fontSize: '2.5rem', fontWeight: 'bold', margin: '30px 0' }}>
            <div>
              <Counter from={0} to={24} />
              <div style={{ fontSize: '1rem', fontWeight: 'normal' }}>Účast na sympoziích</div>
            </div>
            <div>
              <Counter from={0} to={87} />
              <div style={{ fontSize: '1rem', fontWeight: 'normal' }}>Vyrobeno výrobků</div>
            </div>
          </div>
          
          <motion.a 
            href="#vice" 
            className="contact-button"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Více o mně
          </motion.a>
        </div>

        {/* OBRÁZEK S EFEKTEM */}
        <motion.div 
          style={{ flex: '1', minWidth: '300px' }}
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <img src="images/omne.jpg" alt="Řezbář" style={{ width: '100%', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }} />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default About;